<template>
  <div class="myContainer">
    <div class="titleSub">Lemon major events</div>
    <div class="title wow animate__animated durationTime animate__fadeInUp">
      柠檬网联大事件
    </div>
    <div class="changeContent">
      <div class="content" :key="activeTime">
        <div class="time wow animate__animated durationTime animate__fadeInUp">{{title}}</div>
        <div class="text1 wow animate__animated durationTime animate__fadeInUp">{{text1}}</div>
        <div class="text2 wow animate__animated durationTime animate__fadeInUp">
          {{text2}}
        </div>
      </div>
<!--      <div class="content" v-if="activeTime != 0">-->
<!--        <div class="time">2014 - 2016</div>-->
<!--        <div class="text1">成立柠檬网联222</div>-->
<!--        <div class="text2">-->
<!--          柠檬网联成立于2014年3月17日，总部设在中国“硅谷”深圳；222-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="timeLine">
      <div class="stepLeftBtn" @click="changeTime(1)"></div>
      <el-steps :active="-1" align-center class="myStep">
        <el-step
          v-for="(item, index) in timeLineList"
          :key="item.title"
          :title="item.title"
          :class="[activeTime == index ? 'highLight' : '']"
          @click.native="handleStepClick(item)"
        ></el-step>
      </el-steps>
      <div class="stepRightBtn" @click="changeTime(2)"></div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  data() {
    return {
      activeTime: 0,
      title:"",
      text1:"",
      text2:"",
      timeLineList: [
        {

          title: "2014",
          active:0,
          text1:"成立柠檬网联",
          text2:"柠檬网联成立于2014年3月17日，总部设在中国“硅谷”深圳；",
        },
        {
          title: "2014至2016",
          active:1,
          text1:"获得亿元融资",
          text2:"先后获得腾讯、广发信德、招商银科、分享投资、中国风险投资有限公司、吉富创投等国内知名机构数亿元投资。",
        },
        {
          title: "2016",
          active:2,
          text1:"新三板挂牌上市",
          text2:"新三板挂牌上市—柠檬网联（代码：835924）",
        },
        {
          title: "2017",
          active:3,
          text1:"通过国家高新技术认定",
          text2:"首次通过国家高新技术认定",
        },
        {
          title: "2020",
          active:4,
          text1:"富士康全面上线",
          text2:"富士康全国园区中最后一个园区无线网络项目验收上线；" +
            "再次通过国家高新企业复审；",
        },
        {
          title: "2021",
          active:5,
          text1:"签约比亚迪",
          text2:"与比亚迪签署全国园区无线网络合作协议，成为比亚迪官方WiFi合作伙伴；",
        },
        {
          title: "2022",
          active:6,
          text1:"通过全面体系认证",
          text2:"通过ISO9001,14001,45001,20000,27001等全面体系认证，凭借对客户和用户的卓越服务表现获得“五星级服务”体系认证。",
        },
        {
          title: "2023",
          active:7,
          text1:"获得国家级专精特新“小巨人”认定；",
          text2:"服务超2000家B端客户，累计联网终端数5000万，业务覆盖城市超200座，成为富士康、比亚迪、立讯、昌硕等知名企业和一大批中高等院校的首选合作伙伴；",
        },
        {
          title: "2024",
          active:8,
          text1:"十周年之际",
          text2:"全面开放精心熬制十年的园区无线网络软件、硬件、平台一体化解决方案和规建营维一整套运营能力，推出全新升级的商业模式“x计划”，与全国合作伙伴共赢职教校园网络市场亿万蓝海。",
        }
      ]
    };
  },
  computed: {},
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  created() {
    this.handleStepClick(this.timeLineList[0])
  },
  methods: {
    // handleStepClick(item, index) {
    //   this.activeTime = index;
    // },
    handleStepClick(item) {
      this.activeTime = item.active;
      this.title=item.title;
      this.text1=item.text1;
      this.text2=item.text2;
    },
    changeTime(type){
      const lengthIndex = this.timeLineList.length-1
      if(type == 1){
        // 前进
        this.activeTime = this.activeTime == 0 ? lengthIndex : this.activeTime - 1
      }else{
        // 后退
        this.activeTime = this.activeTime == lengthIndex ? 0 : this.activeTime + 1
      }
      this.handleStepClick(this.timeLineList[this.activeTime])
    }
  }
};
</script>

<style scoped lang="scss">
.myContainer {
  width: 100%;
  height: 10.8rem;
  background: url(../../../assets/image/about/developmentBg.png) center
    no-repeat;
  background-size: cover;
  padding: 0 2.18rem;
  position: relative;
  overflow: hidden;
  .title {
    font-size: 0.34rem;
    font-weight: 500;
    margin-top: 3.05rem;
    position: relative;
    color: #fff;
    display: inline-block;
    margin-bottom: 1rem;
  }
  .titleSub {
    position: absolute;
    margin-top: 2.8rem;
    font-size: 0.34rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.51);
    letter-spacing: 0.02rem;
  }

  .changeContent {
    .content {
      font-size: 0.16rem;
      color: #fff;
      .time {
        font-family: Skia, Skia;
        font-weight: bold;
        font-size: 0.8rem;
        color: #fef100;
        text-shadow: 0.1rem 0.05rem 0.04rem rgba(#c5c374, 0.8);
        margin-bottom: 0.4rem;
      }
      .text1 {
        font-size: 0.3rem;
        margin-bottom: 0.2rem;
      }
      .text2{
        width: 9rem;
        line-height: 0.3rem;
        font-size: 0.16rem;
      }
    }
  }

  .timeLine {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 3.6rem;
    .myStep {
      flex: 1;
    }
    .stepLeftBtn,
    .stepRightBtn {
      width: 0.5rem;
      height: 0.5rem;
      border: none;
      background-image: url(../../../assets/image/about/stepBtn.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 50%;
      position: absolute;
      top: -0.12rem;
      left: 2.18rem;
      cursor: pointer;
      &:hover {
        background-image: url(../../../assets/image/about/stepBtnHover.png);
      }
      &::after {
        display: block;
        content: "";
        width: 1.6rem;
        height: 0.01rem;
        background: #fff;
        position: absolute;
        top: 0.24rem;
        left: 0.5rem;
      }
    }

    .stepRightBtn {
      transform: rotate(180deg);
      left: auto;
      right: 2.18rem;
      &::after {
        left: auto;
        right: -1.6rem;
        width: 1.6rem;
      }
    }
  }
}
</style>

<style scoped>
.myStep {
  .el-step__head.is-wait {
    border-color: #fff;
  }
  .el-step.is-horizontal .el-step__line {
    height: 0.01rem;
    top: 0.13rem;
  }
  .el-step__icon.is-text {
    width: 0.12rem;
    height: 0.12rem;
    margin-top: 0.07rem;
    cursor: pointer;
  }
  .el-step__title {
    font-size: 0.2rem;
    line-height: 1.5;
    padding-top: 0.3rem;
    color: #fff !important;
  }
  .el-step__icon-inner {
    display: none;
  }
  .highLight {
    .el-step__icon {
      position: relative;
      &::before,
      &::after {
        display: block;
        content: "";
        position: absolute;
        width: 0.3rem;
        height: 0.3rem;
        border: solid 1px #fff;
        border-radius: 50%;
        animation: hisfont 1s infinite;
      }
      &::before {
        animation-delay: 0.5s;
      }
    }
  }
}

@keyframes hisfont {
  from {
    width: 0.12rem;
    height: 0.12rem;
    opacity: 1;
  }
  to {
    width: 0.45rem;
    height: 0.45rem;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/components/development.vue